import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@walmart-web/livingdesign-components';
import Grid from '@mui/material/Grid';
import { Box, Table, TableBody, TableHead, TableRow } from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { colors } from '../../theme/color-palette';

export default function ShimmerRepInStock() {
	const useStyles = makeStyles(() => ({
		container: {
			margin: '24px 16px',
			border: '1px solid #dadce0',
			borderRadius: '8px',
			height: '120px',
			width: '95%',
		},
		metricPanel: {
			display: 'flex',
			justifyContent: 'space-between',
			padding: '24px',
		},
		metricTab: {
			display: 'flex',
			flexDirection: 'column',
		},
		metricTabInfo: {
			marginTop: '6%',
			display: 'flex',
			flexDirection: 'column',
			gap: '16px',
		},
		rcaHeader: {
			padding: '0px 16px',
			paddingTop: '24px',
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
		},
	}));

	const classes = useStyles();
	const rows = [1, 2, 3, 4, 5, 6];

	return (
		<Grid className={classes.header}>
			<Grid item xs={12} sm={12} md={12} lg={12}>
				<Box className={classes.rcaHeader}>
					<Skeleton height="14.5px" width="100px" variant="rounded" />
				</Box>

				<Box className={classes.container}>
					<Box className={classes.metricPanel}>
						{[1, 2, 3, 4, 4]?.map((tab) => (
							<Box key={tab.value} className={classes.metricTab}>
								<Skeleton height="14.5px" width="100px" variant="rounded" />

								<Box className={classes.metricTabInfo}>
									<Skeleton height="12.5px" width="100px" variant="rounded" />
								</Box>
							</Box>
						))}
					</Box>
				</Box>
				<Table sx={{ width: '100%' }}>
					<TableHead
						sx={{
							'&:first-child td, &:first-child th': { border: 0 },
						}}>
						<TableRow
							sx={{
								backgroundColor: colors.WHITE_GREY,
							}}>
							<TableCell>
								<Skeleton height="11px" width="104px" variant="rounded" />
							</TableCell>
							<TableCell>
								<Skeleton height="11px" width="104px" variant="rounded" />
							</TableCell>
							<TableCell>
								<Skeleton height="11px" width="104px" variant="rounded" />
							</TableCell>
							<TableCell>
								<Skeleton height="11px" width="104px" variant="rounded" />
							</TableCell>
							<TableCell>
								<Skeleton height="11px" width="104px" variant="rounded" />
							</TableCell>
							<TableCell>
								<Skeleton height="11px" width="104px" variant="rounded" />
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{rows?.map((row) => (
							<TableRow
								key={row.name}
								sx={{
									[`& .${tableCellClasses.root}`]: {
										padding: '15px',
									},
								}}>
								<TableCell component="th" scope="row">
									<Skeleton height="11px" width="100px" variant="rounded" />
								</TableCell>
								<TableCell>
									<Skeleton height="11px" width="100px" variant="rounded" />
								</TableCell>
								<TableCell>
									<Skeleton height="11px" width="100px" variant="rounded" />
								</TableCell>
								<TableCell>
									<Skeleton height="11px" width="100px" variant="rounded" />
								</TableCell>
								<TableCell>
									<Skeleton height="11px" width="100px" variant="rounded" />
								</TableCell>
								<TableCell>
									<Skeleton height="11px" width="100px" variant="rounded" />
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</Grid>
		</Grid>
	);
}
